let language = {
    "LBL_HOME":"Home",
    "LBL_CREATE_APPLLICATION":"Create Application",
    "LBL_VIEW_APPLLICATION":"View Application",
    "LBL_APPLICATION_TITLE":"Application Title",
    "LBL_PROJECT_TITLE":"Application Title",
    "LBL_STRA_PRIORITY":"Strategic Priority",
    "LBL_PRIORITY":"St. Prio",
    "LBL_PROGRAM":"Program",
    "LBL_STATUS":"Status",
    "LBL_APPLICATION_DATE":"Application Created On",
    "LBL_APPLICATION_NOTE":"Application Note",
    "LBL_CREATED_ON":"Created On",
    "LBL_RELATED_LINKS":"Related Links",
    "LBL_UPLOAD_DOCS":"Upload Document", 
    "LBL_OPPORTUNITY_TITLE":'Opportunity',
    "LBL_APPLICATION_NO":'Application No.',
    "LBL_APP_EMAIL":'View Emails',
    "LBL_BUDGET_TEMPLATE":"Add Budget",
    "LBL_BUDGET":"Budget",
    "LBL_RELATED_APP_OPP":"Related Application & Opportunity",
    "LBL_OPP_TITLE":"Opportunity Title",
    "LBL_FUNDER":"Funder",
    "LBL_FUNDER_LINK":"Website link",
    "LBL_EXPT_BUDGET":"Budget",
    "LBL_DEADLINE":"Application Deadline",
    "LBL_WORK_PACKAGE":"Application Package",
    "LBL_DOWNLOAD_PACKAGE":"Download Package",
    "LBL_WORK_PACK_NAME":"Application Package Name",
    "LBL_DETAILS":"Details",
    "LBL_REMINDER":"Reminder",
    "LBL_BUDGETS":"Budgets",
    "LBL_DOCUMENTS":"Documents",
    "LBL_COMMENTS":"Comments",
    "LBL_ACTIVITY_STREAM":"Activity Stream",
    "LBL_DUE_DATE":"Due Date",
    "LBL_SPECIFIC_DATE":"Specific Date",
    "LBL_REMINDER_TYPE":"Reminder Type",
    "LBL_TIME":"Time",
    "LBL_NOTIFY_USER":"Notify User",
    "LBL_SET_REMINDER":"Set Reminder",
    "LBL_SELECT_DATE":"Select Date",
    "LBL_USER":"User",
    "LBL_DATE":"Date",
    "LBL_ATTACH_FILES":"Attach Files",
    "LBL_SNO":"S.No.",
    "LBL_TYPE":"Type",
    "LBL_NAME":"Name",
    "LBL_UPLOAD_DATE":"Upload Date",
    "LBL_DOWNLOAD":"Download",
    "LBL_STUDY_BUDGET":"Study Budget Name",
    "LBL_CURRENCY_MULTIPLIER":"Currency Multiplier",
    "LBL_PROJECT_NAME":"Project Name",
    "LBL_ADD_COMMENT":"Add Comment",
    "LBL_RELATED_OPPORTUNITY":"Related Opportunity",
    "LBL_OPPORTUNITY_BUDGET":"Budget Name",
    "LBL_DESCRIPTION":"Description",
    "LBL_SCHEME_TYPE":"Funding type",
    "LBL_COUNTRY":"Country",
    "LBL_RM_NAME":"RM Name",
    "LBL_SERIAL_NO":"S.No.",
    "LBL_STAGE":"Stage",
    "LBL_APPLICATION_BY":"Created By",
    "LBL_OPPORTUNITY_BY":"Opportunity Owner",
    "LBL_OPPORTUNITY_SCOPE":"Scope",

    "LBL_UNDER_REVIEW":"Under development",
    "LBL_APP_READY_FOR_REVIEW":"Application ready for review",
    "LBL_TECHNICAL_REVIEW":"Technical review",
    "LBL_FM_REVIEW":"FM review",
    "LBL_ED_APPROVAL":"ED approval",
    "LBL_PENDING_SUBMISSION":"Pending submission",
    "LBL_SUBMITTED":"Submitted",
    "LBL_PUBLIC_CALL":"Public Calls",
    "LBL_PRIVATE_CALL":"Private Calls",
    "LBL_COMMNET":"Comments",
    "LBL_ACTIVE_STREAM":"Activity Stream",
    "LBL_TEAM_MEMBER":"Team Member",
    "LBL_MEMBER_NAME":"Member Name",
    "LBL_MEMBER_MOBILE":"Member Mobile",
    "LBL_PROFESSIONAL":"Professional",
    "LBL_DESCRIPTION":"Description",
    "LBL_ACTION":"Action",
    "LBL_MEMBER_BUDGET":"Member Budget Access",
    "LBL_BUDGET_ACCESS":"Budget Access ?",
    "LBL_PEER_REVIEW_TIMELINE":"Peer Review Timeline",
    "LBL_SUBMITION_DATE":"Submission to be completed by",
    "LBL_PEER_COMMENT_DATE":"Peer review comments to be received by",
    "LBL_BUDGET_SHARED_DATE":"Budget to be shared by",
    "LBL_PROPOSAL_SHARED_DATE":"Proposal to be shared by",

    "LBL_NOTE":"Note",
    "LBL_EOI":"Intent To Submit",
    "LBL_EOI_BY":"Intent To Submit By",
    "LBL_CREATED_ON":"Created On",
    "LBL_EOI_STATUS":"Status",
    "LBL_PI":"PI",
    "LBL_FINAL_DOCUMENT":"Final Document",
    "LBL_DOCUMENT_NAME":"Document Name",
    "LBL_REVIEWER_DOCUMENT":"Reviewer Document",
    "LBL_UPLOAD_BY":"Upload by",

    "LBL_NEW_MESSAGE":"New Message",
    "LBL_EMAIL_TO":"To",
    "LBL_EMAIL_CC":"Cc",
    "LBL_EMAIL_SUBJECT":"Subject",
    "LBL_EMAIL_ATTACHMENT":"Attachment",
    "LBL_ITEMS":"Items",
    "LBL_UNITS":"Units",
    "LBL_MONTHS":"Month",
    "LBL_PERCENT_OF_TIME":"% of Time",
    "LBL_COST_PER_MONTH":"Cost/Month",
    "LBL_YEAR1":"year 1",
    "LBL_YEAR2":"year 2",
    "LBL_YEAR3":"year 3",
    "LBL_YEAR4":"year 4",
    "LBL_YEAR5":"year 5",
    "LBL_YEAR6":"year 6",
    "LBL_YEAR7":"year 7",
    "LBL_YEAR8":"year 8",
    "LBL_YEAR9":"year 9",
    "LBL_YEAR10":"year 10",
    "LBL_TOTAL_INR":"Total INR",
    "LBL_TOTAL_USD":"Total Ot.Curr",
    "LBL_NOTES":"Notes",
    "LBL_FILE_SIZE":"You can select upto 5 files & upto 7MB at once",
    "LBL_HAS_ATTACHMENT":"Has Attachment?",
    "LBL_SELECT_FILE":"Select File",
}

export default language;
